var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "邀请成员",
        width: "800px",
        visible: _vm.show,
        "close-on-click-modal": false
      },
      on: {
        open: function($event) {
          return _vm.open()
        },
        close: function($event) {
          return _vm.close()
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "dialog-box" },
        [
          _c("i", {
            staticClass: "warn-img el-icon-warning",
            staticStyle: { "vertical-align": "top", "margin-top": "3px" }
          }),
          _c("p", { staticClass: "warn-text" }, [
            _vm._v(
              "邀请成员加入，授权给对方印章、模板，被授权的成员则可代表企业发起、审批、签署文件；若想通过邮箱邀请成员，请前往国际版本"
            )
          ]),
          _c(
            "el-form",
            {
              ref: "dialogModelAddMember",
              attrs: {
                rules: _vm.formAddMemberRules,
                "label-position": "right",
                "label-width": "0",
                model: _vm.dialogModelAddMember
              }
            },
            [
              _vm.dialogModelAddMember.type === 0
                ? _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "45%", display: "inline-block" },
                      attrs: { label: "", prop: "phone" }
                    },
                    [
                      _c(
                        "p",
                        {
                          staticStyle: { height: "20px", "line-height": "20px" }
                        },
                        [
                          _c("span", { staticStyle: { color: "#ec1c1c" } }, [
                            _vm._v("*")
                          ]),
                          _vm._v("手机号")
                        ]
                      ),
                      _c("el-input", {
                        staticStyle: { width: "260px" },
                        attrs: {
                          size: "mini",
                          maxlength: 11,
                          placeholder: "请输入手机号"
                        },
                        model: {
                          value: _vm.dialogModelAddMember.phone,
                          callback: function($$v) {
                            _vm.$set(_vm.dialogModelAddMember, "phone", $$v)
                          },
                          expression: "dialogModelAddMember.phone"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.dialogModelAddMember.type === 1
                ? _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "45%", display: "inline-block" },
                      attrs: { label: "", prop: "email" }
                    },
                    [
                      _c(
                        "p",
                        {
                          staticStyle: { height: "20px", "line-height": "20px" }
                        },
                        [
                          _c("span", { staticStyle: { color: "#ec1c1c" } }, [
                            _vm._v("*")
                          ]),
                          _vm._v("邮箱")
                        ]
                      ),
                      _c("el-input", {
                        staticStyle: { width: "260px" },
                        attrs: {
                          size: "mini",
                          maxlength: 32,
                          placeholder: "请输入邮箱"
                        },
                        model: {
                          value: _vm.dialogModelAddMember.email,
                          callback: function($$v) {
                            _vm.$set(_vm.dialogModelAddMember, "email", $$v)
                          },
                          expression: "dialogModelAddMember.email"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.dialogModelAddMember.type === 0
                ? _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "45%", display: "inline-block" },
                      attrs: { label: "", prop: "name" }
                    },
                    [
                      _c(
                        "p",
                        {
                          staticStyle: { height: "20px", "line-height": "20px" }
                        },
                        [
                          _c("span", { staticStyle: { color: "#ec1c1c" } }, [
                            _vm._v("*")
                          ]),
                          _vm._v("姓名")
                        ]
                      ),
                      _c("el-input", {
                        staticStyle: { width: "260px" },
                        attrs: {
                          size: "mini",
                          maxlength: 32,
                          placeholder: "请输入姓名"
                        },
                        model: {
                          value: _vm.dialogModelAddMember.name,
                          callback: function($$v) {
                            _vm.$set(_vm.dialogModelAddMember, "name", $$v)
                          },
                          expression: "dialogModelAddMember.name"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.dialogModelAddMember.type === 1
                ? _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "45%", display: "inline-block" },
                      attrs: { label: "", prop: "enterpriseName" }
                    },
                    [
                      _c(
                        "p",
                        {
                          staticStyle: { height: "20px", "line-height": "20px" }
                        },
                        [
                          _c("span", { staticStyle: { color: "#ec1c1c" } }, [
                            _vm._v("*")
                          ]),
                          _vm._v("企业名称")
                        ]
                      ),
                      _c("el-input", {
                        staticStyle: { width: "260px" },
                        attrs: {
                          size: "mini",
                          maxlength: 32,
                          placeholder: "请输入企业名称"
                        },
                        model: {
                          value: _vm.dialogModelAddMember.enterpriseName,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.dialogModelAddMember,
                              "enterpriseName",
                              $$v
                            )
                          },
                          expression: "dialogModelAddMember.enterpriseName"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "", prop: "department" } },
                [
                  _c(
                    "p",
                    { staticStyle: { height: "20px", "line-height": "20px" } },
                    [
                      _c("span", { staticStyle: { color: "#ec1c1c" } }, [
                        _vm._v("*")
                      ]),
                      _vm._v("部门")
                    ]
                  ),
                  _c(
                    "el-popover",
                    {
                      attrs: {
                        placement: "right",
                        width: "250",
                        trigger: "click"
                      },
                      model: {
                        value: _vm.visibleChangeSelectStatus,
                        callback: function($$v) {
                          _vm.visibleChangeSelectStatus = $$v
                        },
                        expression: "visibleChangeSelectStatus"
                      }
                    },
                    [
                      _c("el-tree", {
                        staticClass: "member-tree",
                        staticStyle: {
                          "max-height": "400px",
                          "overflow-y": "auto"
                        },
                        attrs: {
                          data: _vm.treeGroup,
                          "highlight-current": true,
                          "expand-on-click-node": false,
                          "node-key": "corpGroupId",
                          "default-expand-all": true,
                          props: _vm.defaultProps
                        },
                        on: { "node-click": _vm.handleNodeClickSelect },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var node = ref.node
                              var data = ref.data
                              return _c(
                                "div",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { title: data.groupName }
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "name",
                                      staticStyle: {
                                        overflow: "hidden",
                                        "white-space": "nowrap",
                                        "text-overflow": "ellipsis",
                                        "max-width": "100%",
                                        "padding-right": "50px"
                                      }
                                    },
                                    [_vm._v(_vm._s(data.groupName))]
                                  )
                                ]
                              )
                            }
                          }
                        ])
                      }),
                      _c(
                        "el-input",
                        {
                          staticStyle: { width: "260px" },
                          attrs: {
                            slot: "reference",
                            readonly: "",
                            size: "mini",
                            placeholder: "请选择"
                          },
                          slot: "reference",
                          model: {
                            value: _vm.dialogModelAddMember.departmentName,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.dialogModelAddMember,
                                "departmentName",
                                $$v
                              )
                            },
                            expression: "dialogModelAddMember.departmentName"
                          }
                        },
                        [
                          _c("i", {
                            class: {
                              "el-icon-arrow-down": true,
                              "custom-transform-rotateZ-180":
                                _vm.visibleChangeSelectStatus,
                              "custom-transform-rotateZ-0": !_vm.visibleChangeSelectStatus
                            },
                            staticStyle: {
                              "font-size": "15px",
                              color: "#cccccc"
                            },
                            attrs: { slot: "suffix" },
                            slot: "suffix"
                          })
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.seals.length > 0
                ? _c("el-form-item", { attrs: { label: "" } }, [
                    _c("span", [_vm._v("选择授权给成员的印章")]),
                    _c(
                      "div",
                      { staticClass: "seal-box" },
                      _vm._l(_vm.seals, function(seal, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "seal-item",
                            class: [seal.select ? "seal-select" : "unselect"],
                            attrs: { id: "sealMenu" + index },
                            on: {
                              click: function($event) {
                                return _vm.selectItem(seal)
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "bo-top" }, [
                              _c("img", { attrs: { src: seal.sealUrl } })
                            ]),
                            _c("p", [_vm._v(_vm._s(seal.sealName))])
                          ]
                        )
                      }),
                      0
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function($event) {
                  return _vm.close()
                }
              }
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                size: "small",
                type: "primary",
                disabled: _vm.onlyClickOnce
              },
              on: {
                click: function($event) {
                  return _vm.addMemberSubmit()
                }
              }
            },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51554ab8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51554ab8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/console/addMember.vue
// module id = 85dL
// module chunks = 1 7 11 40